// libraries
import { buildFromConfig } from '@makemydeal/dr-common-utils';
import { configureCustomerCard } from '@makemydeal/dr-activities-customer-card';

// interfaces/types
import type { SalesCheckinRootState } from '@makemydeal/dr-sales-checkin-store';

/**
 * Configure the Deal Central customer-card activity with the Sales Check-in BFF base URL.
 *
 * The activity appends `/deal/{dealId}/participants` (and `/sync-customer`) when the card
 * saves, so it needs the BFF origin.
 */
export const configureSalesCheckinCustomerCard = (state: SalesCheckinRootState) => {
    const bffBaseUrl = buildFromConfig(state.config.services.bff);
    // SCI has no legacy/unified fallback — CustomerInformationCard always renders the activities card.
    return configureCustomerCard({ bffBaseUrl, hostApp: 'SCI', customerCardVariant: 'activities' });
};
